import { CircleHelp } from "lucide-react";
import React from "react";
import { slab } from "./faqConstants";

type FaqPanelHeaderProps = {
  description: string;
  firestorePath: string;
};

export const FaqPanelHeader: React.FC<FaqPanelHeaderProps> = ({
  description,
  firestorePath,
}) => (
  <header className="mb-8 text-center sm:mb-10">
    <h1 className="mb-2 flex flex-wrap items-center justify-center gap-2 text-3xl font-extrabold tracking-tight text-white drop-shadow-sm sm:gap-3 sm:text-4xl">
      <span
        className="inline-flex h-12 w-12 items-center justify-center rounded-2xl text-white shadow-[0_4px_0_#0F766E] sm:h-14 sm:w-14"
        style={{ backgroundColor: slab.teal }}
      >
        <CircleHelp
          className="h-7 w-7 sm:h-8 sm:w-8"
          strokeWidth={2.25}
          aria-hidden
        />
      </span>
      <span className="max-w-[18ch] leading-tight sm:max-w-none">
        In-app FAQ
      </span>
    </h1>
    <p className="mx-auto max-w-xl text-base font-bold text-white/80 sm:text-lg">
      {description}
    </p>
  </header>
);
